/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagePostImageSvg } from "../../funcs/imagePostImageSvg.js";
import { PostImageSvgRequest$zodSchema } from "../../models/postimagesvgop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostImageSvgRequest$zodSchema.optional(),
};

export const tool$imagePostImageSvg: ToolDefinition<typeof args> = {
  name: "image-post-image-svg",
  description: `SVG转图片

需要将灵活的 SVG 矢量图形转换为常见的光栅图像格式吗？这个接口可以帮你轻松实现。

## 功能概述
上传一个 SVG 文件，并指定目标格式（如 PNG、JPEG 等），接口将返回转换后的图像。你还可以调整输出图像的尺寸和（对于JPEG）压缩质量，以满足不同场景的需求。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await imagePostImageSvg(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
